import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PaymentTerm } from '../models/payment-term.model';
import { OrdinalDatePipe } from '../../shared/pipes/ordinal-date.pipe';
import { SeFeThemesLoader } from 'se-fe-themes';

@Component({
  selector: 'app-payment-term-preview',
  templateUrl: './payment-term-preview.component.html',
  styleUrls: ['./payment-term-preview.component.scss'],
  providers: [ OrdinalDatePipe ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PaymentTermPreviewComponent implements OnChanges {
  dueDateParams: object;
  dueInFull: boolean;
  hasCustomDates: boolean;
  installmentWindow: string;
  previewPercentages: number[];

  @Input() paymentTerm: PaymentTerm;
  @Input() paymentTermForm?: FormGroup;
  @Input() saleType: string;

  constructor(private ordinal: OrdinalDatePipe) {
    SeFeThemesLoader.load({
      supportedThemes: 'light',
      url: 'https://se-fe-angular-services.ui.sportngin.com'
    });
   }

  ngOnChanges(): void {
    this.dueDateParams = {
      interval: this.paymentTerm.payment_term_strategy.interval,
      ordinalDate: this.ordinal.transform(this.paymentTerm.payment_term_strategy.day_of_month)
    };
    this.dueInFull = this.paymentTerm.payment_term_strategy.strategy_type === 'due_in_full';
    this.hasCustomDates = this.paymentTerm.payment_term_strategy.strategy_type === 'custom_date';
    this.installmentWindow = this.paymentTerm.payment_term_strategy.installment_window;
    this.previewPercentages = this.paymentTerm.payment_term_strategy.preview_percentages;
  }
}
